module.exports = __webpack_public_path__ + "img/06.24f1ff9f.jpg";